import { Separator } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

const WorkspaceListViewSkeleton = () => {
  return (
    <div className="">
      {/* Header */}
      <div className="mb-4 flex-1">
        <div className="flex items-center gap-2 flex-row w-72">
          <Skeleton className="col-span-2 size-10 rounded-full" />
          <div className="flex flex-col flex-1">
            <Skeleton className="h-6 rounded w-full mb-2" />
            <Skeleton className="h-4 rounded w-3/4" />
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <Skeleton className="h-6 rounded w-1/5 mb-4" />
        <div className="flex flex-row mb-2">
          <Skeleton className="h-4 rounded w-1/6" />
          <Skeleton className="ml-4 h-4 rounded w-20" />
        </div>
      </div>
      {/* Separator selections */}
      <div className="flex flex-row gap-6 mb-1 mt-4">
        <Skeleton className=" h-7 w-20 rounded" />
        <Skeleton className=" h-7 w-32 rounded" />
        <Skeleton className=" h-7 w-32 rounded" />
      </div>
      <Separator className="mb-6" />
      {/* Search Bar */}
      <div className="flex flex-row flex-1 gap-4 mb-6">
        <Skeleton className=" h-9 w-full rounded" />
        <Skeleton className=" h-9 w-[15%] rounded" />
        <Skeleton className=" h-9 w-[15%] rounded" />
      </div>

      {/* Skeleton Rows */}
      <div className="flex flex-col h-[calc(100vh-200px)] overflow-y-auto">
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-row flex-1 gap-4 items-center mb-4"
          >
            {/* File Icon and Name */}
            <div className="flex-1 flex gap-2">
              <div className="h-[82px] rounded items-center border flex flex-1 flex-row justify-between">
                <div className="flex flex-row items-center w-1/3">
                  {/* File Icon */}
                  <Skeleton className="size-6 items-center rounded mx-4" />
                  <div className="flex flex-col items-start flex-1 ">
                    {/* File Name and date */}
                    <Skeleton className="h-4 w-2/3 items-center rounded mb-2" />
                    <Skeleton className="h-4 w-3/5 items-center rounded " />
                  </div>
                </div>

                {/* Uploaded by */}
                <div className="flex flex-row items-center w-[18%]">
                  <Skeleton className="col-span-2 size-8 min-h-8 min-w-8 rounded-full" />
                  <Skeleton className="h-4 w-20 rounded ml-4 mr-2" />
                  <Skeleton className="h-4 w-24 rounded mr-4" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkspaceListViewSkeleton;
